/** 下拉選項唯一鍵（enName + areaCode，避免 +1 等重複區號） */
export function buildCountryOptionKey(country) {
  if (!country?.enName) {
    return '';
  }
  return `${country.enName}::${country.areaCode || ''}`;
}

/** 正規化 country 表 API 回傳 */
export function normalizeCountryList(list) {
  if (!Array.isArray(list)) {
    return [];
  }
  return list.filter((item) => item?.enName && item?.zhName);
}

export function findCountryByOptionKey(countries, optionKey) {
  if (!optionKey || !Array.isArray(countries)) {
    return null;
  }
  return countries.find((item) => buildCountryOptionKey(item) === optionKey) || null;
}

export function findCountryByEnName(countries, enName, areaCode) {
  if (!enName || !Array.isArray(countries)) {
    return null;
  }
  if (areaCode) {
    const exact = countries.find(
      (item) => item.enName === enName && item.areaCode === areaCode
    );
    if (exact) {
      return exact;
    }
  }
  return countries.find((item) => item.enName === enName) || null;
}

/** 依後台 register.enNames 過濾可選國家 */
export function filterCountriesByEnNames(countries, enNames) {
  if (!Array.isArray(countries) || countries.length === 0) {
    return [];
  }
  if (!Array.isArray(enNames) || enNames.length === 0) {
    return countries;
  }
  const allowed = new Set(enNames);
  return countries.filter((item) => allowed.has(item.enName));
}

export function formatAreaCode(areaCode) {
  const trimmed = String(areaCode || '').trim();
  if (!trimmed) {
    return '';
  }
  return trimmed.startsWith('+') ? trimmed : `+${trimmed}`;
}

/** country.delFlag：0 或未設為啟用 */
export function isCountryEnabled(country) {
  if (!country) {
    return false;
  }
  const flag = country.delFlag;
  return flag === 0 || flag === null || flag === undefined;
}

/** 依 delFlag 與 sort 解析已啟用國家 option key（enName::areaCode） */
export function resolveEnabledCountryKeys(countries) {
  return (countries || [])
    .filter(isCountryEnabled)
    .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0) || String(a.enName).localeCompare(String(b.enName)))
    .map((item) => buildCountryOptionKey(item))
    .filter(Boolean);
}

export function buildCountryAdminItems(countries) {
  return (countries || [])
    .filter((item) => item?.enName)
    .map((item) => ({
      key: buildCountryOptionKey(item),
      label: formatCountryAdminLabel(item),
      raw: item,
    }));
}

export function formatCountryAdminLabel(country) {
  if (!country) {
    return '';
  }
  const area = formatAreaCode(country.areaCode);
  const name = country.zhName || country.enName || '';
  return area ? `${area}, ${name}` : name;
}

export function formatCountryOptionLabel(country) {
  if (!country) {
    return '';
  }
  const area = formatAreaCode(country.areaCode);
  return area ? `${country.zhName} (${area})` : country.zhName;
}

/** 預設台灣，否則取列表第一筆 */
export function pickDefaultCountry(countries) {
  if (!Array.isArray(countries) || countries.length === 0) {
    return null;
  }
  return countries.find((item) => item.enName === 'Taiwan') || countries[0];
}

export function countryToPhoneFields(country) {
  if (!country) {
    return { countryKey: '', countryEnName: '', phoneAreaCode: '' };
  }
  return {
    countryKey: buildCountryOptionKey(country),
    countryEnName: country.enName,
    phoneAreaCode: country.areaCode?.trim() || '',
  };
}
